/**
 * @generated SignedSource<<dc0788dc48f6a945a7dcbf579fcbdedf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TwoAssetsExchangeRateQuery$variables = {
  sourceAssetId: string;
  targetAssetId: string;
};
export type TwoAssetsExchangeRateQuery$data = {
  readonly exchangeRate: PrecisionFloat | null | undefined;
};
export type TwoAssetsExchangeRateQuery = {
  response: TwoAssetsExchangeRateQuery$data;
  variables: TwoAssetsExchangeRateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sourceAssetId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "targetAssetId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "sourceAssetId",
        "variableName": "sourceAssetId"
      },
      {
        "kind": "Variable",
        "name": "targetAssetId",
        "variableName": "targetAssetId"
      }
    ],
    "kind": "ScalarField",
    "name": "exchangeRate",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TwoAssetsExchangeRateQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TwoAssetsExchangeRateQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d55b1a5db610dedf6a5b10e38a50f8f7",
    "id": null,
    "metadata": {},
    "name": "TwoAssetsExchangeRateQuery",
    "operationKind": "query",
    "text": "query TwoAssetsExchangeRateQuery(\n  $sourceAssetId: ID!\n  $targetAssetId: ID!\n) {\n  exchangeRate(sourceAssetId: $sourceAssetId, targetAssetId: $targetAssetId)\n}\n"
  }
};
})();

(node as any).hash = "0d7655e4c430da713d380ad7fbdb1bf5";

export default node;
